import { fetchCheckoutsAccount, updateCheckoutsAccount } from '@/services/ApiCategories/checkouts';
import { put, call, takeEvery, fork } from 'redux-saga/effects';
import { ActionTypes, CheckoutsStripeAccountUpdateAction } from '@/store/checkoutsStripeAccount/types';
import {
    CheckoutsStripeAccountFetchError,
    CheckoutsStripeAccountFetchSuccess,
    CheckoutsStripeAccountUpdateError,
    CheckoutsStripeAccountUpdateSuccess,
} from '@/store/checkoutsStripeAccount/actions';
import { CreateAccountConnect } from '@dev/ee-api/ee-api-models';
import { AxiosResponse } from 'axios';
import { Logger } from '@/services/errors/appLogger';
import { errorToast } from './commonGenerators/errorToast';

function* fetchCheckoutsStripeAccount(): any {
    try {
        const checkoutsStripeAccount = yield call(fetchCheckoutsAccount);

        yield put(CheckoutsStripeAccountFetchSuccess(checkoutsStripeAccount?.data));
    } catch (e) {
        yield put(CheckoutsStripeAccountFetchError());
    }
}

function* updateCheckoutsStripeAccount(action: CheckoutsStripeAccountUpdateAction): any {
    try {
        const checkoutsStripeAccountUpdateResponse: AxiosResponse<CreateAccountConnect> = yield call(
            updateCheckoutsAccount,
            action.payload
        );

        const redirectUrl = checkoutsStripeAccountUpdateResponse.data.RedirectUrl;
        if (redirectUrl) {
            window.location.href = redirectUrl;
            return;
        }
        Logger.error('No RedirectUrl found in response');
        yield put(CheckoutsStripeAccountUpdateSuccess(action.meta));
    } catch (e) {
        yield put(CheckoutsStripeAccountUpdateError(action.meta));
        yield call(errorToast, e);
    }
}

function* fetchCheckoutsStripeAccountWatcher(): any {
    yield takeEvery(ActionTypes.FETCH_START, fetchCheckoutsStripeAccount);
}
function* updateCheckoutsStripeAccountWatcher(): any {
    yield takeEvery(ActionTypes.UPDATE_START, updateCheckoutsStripeAccount);
}

const checkoutsStripeAccountSagas = [
    fork(fetchCheckoutsStripeAccountWatcher),
    fork(updateCheckoutsStripeAccountWatcher),
];

export default checkoutsStripeAccountSagas;
